import { Box } from "@mui/material";
import React from "react";
import "../../NewSettings.scss";
import Grid from "@mui/material/Unstable_Grid2";

function ActivityLog() {
  return (
    <Box className="settingMenuWrapper">
      <Grid container spacing={3}>
        <Grid xs={12}>
          <h2>Activity Log</h2>
        </Grid>
        <Grid xs={12} className="text-center">
          <img
            src="./images/coming_soon.svg"
            className="mb-5"
            height="260px"
            alt="coming soon"
          />
          <div className="comingsoon">
            <h1>
              <span></span>
            </h1>
            {/* <div className="load"></div> */}
          </div>
          <h5>We are working on it.</h5>
        </Grid>
      </Grid>
    </Box>
  );
}

export default ActivityLog;
